var _excluded = ["desc", "focusable", "title", "iconName", "className"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import { string, bool } from 'prop-types';
import classNames from 'classnames';
var svg = /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 32 32"
}, /*#__PURE__*/React.createElement("path", {
  d: "M25.707 8.707l-6.414-6.414A1 1 0 0018.586 2H7a1 1 0 00-1 1v26a1 1 0 001 1h18a1 1 0 001-1V9.414a1 1 0 00-.293-.707zM19.5 3.914l5.093 5.093h-3.918A1.257 1.257 0 0119.5 7.828zM25 29H7V3h11.5v4.828a2.234 2.234 0 002.175 2.179H25zM11.498 15.088H9.835v5.084h1.017V18.21h.646a1.568 1.568 0 100-3.123zm-.072 2.23h-.575V15.98h.575c.471 0 .748.247.748.669s-.276.667-.748.667zm4.32-2.23h-1.7v5.084h1.7A2.288 2.288 0 0018.2 17.63a2.289 2.289 0 00-2.454-2.542zm-.022 4.19h-.661v-3.296h.661c.915 0 1.438.602 1.438 1.648s-.523 1.648-1.438 1.648zm3.34.894h1.017v-2.136h1.67v-.886h-1.67v-1.169h2.033v-.893h-3.05z"
}));

var Icon = function Icon(_ref) {
  var desc = _ref.desc,
      _ref$focusable = _ref.focusable,
      focusable = _ref$focusable === void 0 ? false : _ref$focusable,
      title = _ref.title,
      iconName = _ref.iconName,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: String(focusable),
    className: classNames('rds-svg--document-pdf-outline-icon', className)
  }, rest, svg.props), title && /*#__PURE__*/React.createElement("title", null, title), desc && /*#__PURE__*/React.createElement("desc", null, desc), svg.props.children);
};

Icon.propTypes = {
  desc: string,
  focusable: bool,
  title: string,
  iconName: string,
  className: string
};
Icon.displayName = 'DocumentPdfOutlineIcon';
export default Icon;